var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"jump-down"}},[_c('BProgress',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"w-100",attrs:{"value":_vm.percent,"max":"100","height":"0.8rem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }